// src/services/pipelineStatuses.js

const API_BASE = 'https://new.sbdemolition.online/api';

async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    }
  });

  // Handle 401 Unauthorized
  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || error.message || `API Error ${response.status}`);
  }

  return response.json();
}

export const pipelineStatusesAPI = {
  /**
   * Get all active statuses
   * @returns {Promise} List of statuses
   */
  list: () => apiRequest('/pipeline-statuses/list.php'),

  /**
   * Create a new status
   * @param {Object} data - Status data (title, color_scheme, icon_name, display_order)
   * @returns {Promise} Created status
   */
  create: (data) => apiRequest('/pipeline-statuses/create.php', {
    method: 'POST',
    body: JSON.stringify(data)
  }),

  /**
   * Update an existing status
   * @param {string} id - Status ID
   * @param {Object} data - Updated data
   * @returns {Promise} Update result
   */
  update: (id, data) => apiRequest('/pipeline-statuses/update.php', {
    method: 'PUT',
    body: JSON.stringify({ id, ...data })
  }),

  /**
   * Delete a status (soft delete)
   * @param {string} id - Status ID
   * @returns {Promise} Delete result
   */
  delete: (id) => apiRequest(`/pipeline-statuses/delete.php?id=${id}`, {
    method: 'DELETE'
  }),

  /**
   * Reorder statuses (batch update)
   * @param {Array} statuses - Array of statuses with new order
   * @returns {Promise} Reorder result
   */
  reorder: async (statuses) => {
    try {
      const promises = statuses.map((status, index) =>
        apiRequest('/pipeline-statuses/update.php', {
          method: 'PUT',
          body: JSON.stringify({
            id: status.id,
            display_order: index + 1
          })
        })
      );
      
      await Promise.all(promises);
      return { success: true };
    } catch (error) {
      console.error('Failed to reorder statuses:', error);
      throw error;
    }
  }
};
